const generatePoNumber = (poPrefix, getPoMonth, lastCount) => {
  let setMonth = getPoMonth.split("-");
  const year = setMonth[0];
  const month = setMonth[1];
  const generatedNum =
    poPrefix +
    month +
    year.slice(year.length - 2) +
    `${lastCount ? `-${lastCount}` : "-01"}`;
  if (month && year) {
    return generatedNum;
  } else {
    const lastMonth = new Date().getMonth();
    let lastYear = `${new Date().getFullYear()}`;
    lastYear = lastYear.slice(lastYear.length - 2);
    poPrefix =
      poPrefix +
      `${lastMonth}${lastYear}${lastCount ? `-${lastCount}` : "-01"}`;
    return poPrefix;
  }
};

export const generateTDSPoNumber = (poPrefix, getPoMonth) => {
  const date = new Date();
  let year = "";
  year = date.getFullYear();
  const y = year.toString().substr(2, 2);

  const generatedNum = poPrefix + getPoMonth + y + "-01";
  if (year) {
    return generatedNum;
  } else {
    return "";
  }
};

const prefixObj = {
  Internal:"PR-I-",
  External:"PR-E-",
  Resource:"PR-S-",
}
export const generatePOPrefix = (moduleType) => {
 return prefixObj[moduleType]
};

export const formatStrWithColon = (input, maxLength = 9) => {
  // Add colons every 2 characters
  const cleanedInput = input.replace(/[^a-zA-Z0-9]/g, "");
  const formatted = cleanedInput.replace(/(.{2})(?=.)/g, "$1-") + '-';
  return formatted.slice(0, maxLength) 
};
export const formatInvoicePrifix = (input, maxLength = 9) => {
  const cleanedInput = input.replace(/[^a-zA-Z0-9]/g, "");
  // const formatted = cleanedInput.replace(/(.{3})(?=.)/g, "$1-");
  return cleanedInput.slice(0, maxLength) + "-"
};

export const validetPrifix = (input, maxLength = 9) => {
  const length = input.length;
  if (length < 5 || length > maxLength) {
    return false;
  }
  else{
    return true
  }
};
export default generatePoNumber;
